import { useTranslate } from '@tolgee/react';
import CheckboxGroup from './CheckboxGroup';
import { RegionCheckbox } from './RegionCheckbox';
import { Formik } from 'formik';
import { FormContainer, BottomButton, BottomFooter } from './styles';
import FormField from 'components/FormField';
import { RightOutlined } from '@ant-design/icons';
import { GenerateTikTokAuthUrlParams } from 'services/api/tiktok';

interface FormValues {
  storeType?: GenerateTikTokAuthUrlParams['storeType'];
  region?: GenerateTikTokAuthUrlParams['region'];
}
interface TikTokShopTypeProps {
  onNext: (values: FormValues) => void;
  initialValues?: FormValues;
}

const getRegions = (shopType?: string): General.UpperCaseRegion[] => {
  if (shopType === 'CROSS') {
    return ['VN', 'TH', 'MY', 'SG', 'PH', 'GB', 'ES', 'IT', 'DE', 'FR', 'JP', 'MX'];
  }
  if (shopType === 'LOCAL') {
    return [
      'ID',
      'VN',
      'TH',
      'MY',
      'SG',
      'PH',
      'GB',
      'IE',
      'ES',
      'IT',
      'DE',
      'FR',
      'BR',
      'MX',
      'JP',
    ];
  }
  return [];
};

export const TikTokShopType = (props: TikTokShopTypeProps) => {
  const { onNext, initialValues } = props;
  const { t } = useTranslate();

  return (
    <Formik<FormValues>
      initialValues={initialValues || {}}
      onSubmit={(values) => {
        onNext?.(values);
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        const btnDisable = !values.storeType || !values.region;

        return (
          <FormContainer layout="vertical">
            <FormField label={t('authShop.请选择您要添加的店铺类型')} name="storeType" required>
              {({ field }) => (
                <CheckboxGroup
                  options={[
                    {
                      value: 'CROSS',
                      render: <>{t('ViewShops.CROSS')}</>,
                    },
                    {
                      value: 'LOCAL',
                      render: <>{t('ViewShops.LOCAL')}</>,
                    },
                  ]}
                  value={field.value}
                  onChange={(storeType) => {
                    setFieldValue('region', undefined);
                    field.onChange(storeType);
                  }}
                />
              )}
            </FormField>
            {values.storeType && (
              <FormField label={t('authShop.请选择店铺站点')} name="region" required>
                {({ field }) => {
                  const regions = getRegions(values['storeType']);
                  return (
                    <RegionCheckbox
                      options={regions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  );
                }}
              </FormField>
            )}
            <BottomFooter>
              <BottomButton disabled={btnDisable} size="large" type="primary" onClick={submitForm}>
                {t('authShop.下一步')}
                <RightOutlined />
              </BottomButton>
            </BottomFooter>
          </FormContainer>
        );
      }}
    </Formik>
  );
};
